import { useState, useEffect, useRef } from 'react';
import RegisterLink from '@/components/ui/RegisterLink';

const CATEGORIES = [
  { id: 1, iconOff: 'https://xt30sf.b-cdn.net/media/584b557071c86937ed22b.png', iconOn: 'https://xt30sf.b-cdn.net/media/12ee4cc4f329660f04a02.png', label: 'Hot' },
  { id: 3, iconOff: 'https://xt30sf.b-cdn.net/media/a9ac0d9cc0e86a3456c26.png', iconOn: 'https://xt30sf.b-cdn.net/media/cd51f5f4f32964447bdd1.png', label: 'Slots' },
  { id: 4, iconOff: 'https://xt30sf.b-cdn.net/media/3fc713681b69694bc8d26.png', iconOn: 'https://xt30sf.b-cdn.net/media/6ba6c8781b696a923c81f.png', label: 'Fish' },
  { id: 6, iconOff: 'https://xt30sf.b-cdn.net/media/d512e1981b6960b267a4c.png', iconOn: 'https://xt30sf.b-cdn.net/media/f4938d65f32963b88456c.png', label: 'Live' },
];

interface Provider {
  name: string;
  tag: string;
  tagColor: string;
  games: string[];
  accentColor: string;
  categories: number[];
}

const ALL_PROVIDERS: Provider[] = [
  { name: 'JILI', tag: 'HOT', tagColor: '#f87171', accentColor: '#f87171', categories: [1, 3, 4], games: ['Super Ace', 'Golden Empire', 'Fortune Gems', 'Crazy 777', 'Mega Ace', 'Lucky Ball'] },
  { name: 'VPOWER', tag: 'HOT', tagColor: '#f87171', accentColor: '#f87171', categories: [1, 3, 4], games: ['Golden Dragon', 'Lucky Panda', 'Dragon Treasure', 'Fishing War', 'Ocean King'] },
  { name: 'Pragmatic Play', tag: 'POPULAR', tagColor: '#34d399', accentColor: '#34d399', categories: [3, 6], games: ['Gates of Olympus', 'Sweet Bonanza', 'Wolf Gold', 'Starlight Princess', 'Big Bass'] },
  { name: 'PG Soft (PGS)', tag: 'TRENDING', tagColor: '#47CAF1', accentColor: '#47CAF1', categories: [3, 6], games: ['Mahjong Ways', 'Ganesha Gold', 'Wild Bandito', 'Fortune Tiger', 'Candy Burst'] },
  { name: 'BNG (Booongo)', tag: 'HOT', tagColor: '#fbbf24', accentColor: '#fbbf24', categories: [1, 3, 4], games: ['Sweet Fiesta', 'Wild Carnival', 'Treasure Mania', 'Aztec Sun', 'Fruit Burst'] },
  { name: 'EVO888H5', tag: 'LIVE', tagColor: '#a78bfa', accentColor: '#a78bfa', categories: [3], games: ['Live Baccarat', 'Live Roulette', 'Dragon Tiger', 'Sic Bo', 'Blackjack'] },
  { name: 'JDB', tag: 'HOT', tagColor: '#f87171', accentColor: '#f87171', categories: [3, 4], games: ['Fishing God', 'Caishen Riches', 'Lucky Goldenbank', 'Burglar', 'Monkey King'] },
  { name: 'Spade Gaming', tag: 'POPULAR', tagColor: '#fbbf24', accentColor: '#fbbf24', categories: [3, 4], games: ['Fishing War', 'Mayan Gems', 'Alien Hunter', 'Fa Fa Twins', 'Poker King'] },
];

function ProviderCard({ provider }: { provider: Provider }) {
  const [hovered, setHovered] = useState(false);

  return (
    <RegisterLink
      section="games_section"
      linkLabel={provider.name}
      href="https://bybid9.tips/RFLANDINGPAGESEO"
      target="_blank"
      rel="noreferrer"
      className="relative block rounded-2xl overflow-hidden cursor-pointer"
      style={{
        background: hovered
          ? 'rgba(71,202,241,0.08)'
          : 'rgba(255,255,255,0.03)',
        border: hovered
          ? `1px solid ${provider.accentColor}55`
          : '1px solid rgba(71,202,241,0.1)',
        transform: hovered ? 'translateY(-4px)' : 'translateY(0)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        boxShadow: hovered ? `0 8px 32px rgba(71,202,241,0.15)` : 'none',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="p-5">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div
            className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0"
            style={{ background: `${provider.accentColor}18`, border: `1px solid ${provider.accentColor}35` }}
          >
            <i className="ri-gamepad-line text-lg" style={{ color: provider.accentColor }}></i>
          </div>
          <span
            className="text-[10px] font-black tracking-widest px-2.5 py-1 rounded-full"
            style={{ background: `${provider.tagColor}15`, color: provider.tagColor, border: `1px solid ${provider.tagColor}35` }}
          >
            {provider.tag}
          </span>
        </div>

        {/* Name */}
        <h3 className="text-white font-black text-sm mb-3 leading-tight">{provider.name}</h3>

        {/* Game list */}
        <ul className="space-y-1.5 mb-4">
          {provider.games.slice(0, 4).map((g) => (
            <li key={g} className="flex items-center gap-2 text-[#56626B] text-xs">
              <i className="ri-checkbox-circle-line text-[#47CAF1] text-xs flex-shrink-0"></i>
              <span className="truncate">{g}</span>
            </li>
          ))}
        </ul>

        {/* Play button */}
        <div
          className="w-full py-2 rounded-xl text-center text-xs font-black tracking-wide transition-all duration-300"
          style={{
            background: hovered ? `linear-gradient(135deg, ${provider.accentColor}, ${provider.accentColor}cc)` : 'rgba(255,255,255,0.05)',
            color: hovered ? '#0d1117' : 'rgba(255,255,255,0.4)',
            border: hovered ? 'none' : '1px solid rgba(255,255,255,0.08)',
          }}
        >
          {hovered ? 'Play now' : 'View games'}
        </div>
      </div>
    </RegisterLink>
  );
}

export default function GamesSection() {
  const [activeCategory, setActiveCategory] = useState(1);
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const filtered = activeCategory === 1
    ? ALL_PROVIDERS
    : ALL_PROVIDERS.filter((p) => p.categories.includes(activeCategory));

  return (
    <section
      ref={sectionRef}
      className="relative py-14 sm:py-16 md:py-20 px-4 sm:px-5 md:px-8 overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #0d1117 0%, #0a1520 50%, #0d1117 100%)' }}
    >
      <div className="section-divider mb-0 absolute top-0 left-0 w-full" />

      {/* Ambient glow */}
      <div
        className="absolute top-1/2 left-1/4 -translate-y-1/2 w-[500px] h-[500px] rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(71,202,241,0.05) 0%, transparent 70%)', filter: 'blur(60px)' }}
      />

      <div className="relative max-w-7xl mx-auto">
        {/* Header */}
        <div
          className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-4"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 0.6s ease',
          }}
        >
          <div>
            <div className="badge-blue mb-3">
              <i className="ri-gamepad-line" />
              5000+ Real Money Games
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white leading-tight">
              Top Game Providers at{' '}
              <span className="text-gradient-blue">BYBID9</span>
            </h2>
            <p className="text-white/40 text-sm mt-2 max-w-md">
              50+ world-class providers. Slots, Live Casino, Fishing and more, all in one place.
            </p>
          </div>
          <RegisterLink
            section="games_section"
            linkLabel="Play All Games"
            href="https://bybid9.tips/RFLANDINGPAGESEO"
            target="_blank"
            rel="noreferrer"
            className="btn-premium text-sm px-6 py-2.5 self-start sm:self-auto whitespace-nowrap"
          >
            <span className="flex items-center gap-2">
              <i className="ri-external-link-line" />
              Play All Games
            </span>
          </RegisterLink>
        </div>

        {/* Category Tabs */}
        <div
          className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 -mx-1 px-1 snap-x snap-mandatory scroll-pl-3 touch-pan-x"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(16px)',
            transition: 'all 0.6s ease 0.1s',
            scrollbarWidth: 'none',
          }}
        >
          {CATEGORIES.map((cat) => {
            const isActive = activeCategory === cat.id;
            return (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className="flex items-center gap-2 px-4 py-2.5 min-h-[44px] rounded-full text-sm font-bold transition-all duration-250 whitespace-nowrap cursor-pointer flex-shrink-0 snap-start"
                style={
                  isActive
                    ? {
                        background: 'linear-gradient(135deg, #47CAF1, #1a9fc4)',
                        color: '#0d1117',
                        boxShadow: '0 0 20px rgba(71,202,241,0.4)',
                      }
                    : {
                        background: 'rgba(255,255,255,0.05)',
                        color: 'rgba(255,255,255,0.5)',
                        border: '1px solid rgba(255,255,255,0.08)',
                      }
                }
              >
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <img src={isActive ? cat.iconOn : cat.iconOff} alt={cat.label} className="w-5 h-5 object-contain" />
                </div>
                {cat.label}
              </button>
            );
          })}
        </div>

        {/* Provider Cards Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4 mb-10">
          {filtered.map((provider, idx) => (
            <div
              key={provider.name}
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(30px)',
                transition: `all 0.5s cubic-bezier(0.4,0,0.2,1) ${0.1 + idx * 0.05}s`,
              }}
            >
              <ProviderCard provider={provider} />
            </div>
          ))}
        </div>

        {/* Stats bar */}
        <div
          className="glass-card rounded-2xl p-4 sm:p-5 grid grid-cols-2 sm:flex sm:flex-wrap sm:items-center sm:justify-center gap-4 sm:gap-8 mb-8"
          style={{ border: '1px solid rgba(71,202,241,0.12)' }}
        >
          {[
            { value: '5000+', label: 'Total Games', icon: 'ri-gamepad-fill' },
            { value: '50+', label: 'Providers', icon: 'ri-building-line' },
            { value: '4', label: 'Categories', icon: 'ri-layout-grid-line' },
            { value: '24/7', label: 'Available', icon: 'ri-time-line' },
          ].map((s) => (
            <div key={s.label} className="flex items-center gap-3 min-w-0">
              <div className="w-9 h-9 flex items-center justify-center rounded-xl flex-shrink-0" style={{ background: 'rgba(71,202,241,0.1)' }}>
                <i className={`${s.icon} text-[#47CAF1] text-base`}></i>
              </div>
              <div className="min-w-0">
                <div className="text-white font-black text-base sm:text-lg stat-number">{s.value}</div>
                <div className="text-[#56626B] text-[10px] sm:text-xs leading-tight">{s.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div
          className="flex flex-col items-center gap-3"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 0.6s ease 0.6s',
          }}
        >
          <RegisterLink
            section="games_section"
            linkLabel="View All Games"
            href="https://bybid9.tips/RFLANDINGPAGESEO"
            target="_blank"
            rel="noreferrer"
            className="relative inline-flex items-center justify-center gap-3 w-full max-w-md mx-auto px-8 sm:px-12 py-4 min-h-[52px] rounded-2xl font-black text-sm sm:text-base text-[#0d1117] cursor-pointer sm:whitespace-nowrap overflow-hidden"
            style={{
              background: 'linear-gradient(135deg, #47CAF1 0%, #6EDBFF 50%, #47CAF1 100%)',
              backgroundSize: '200% 200%',
              boxShadow: '0 0 40px rgba(71,202,241,0.5), 0 8px 32px rgba(71,202,241,0.3)',
              animation: 'bgShift 4s ease infinite',
            }}
          >
            <i className="ri-gamepad-fill text-lg" />
            View All Games
            <i className="ri-arrow-right-line text-lg" />
          </RegisterLink>
          <p className="text-white/25 text-xs">SSL Secured · 18+ · Play Responsibly</p>
        </div>
      </div>
    </section>
  );
}
